import { ReferralTransaction } from '@/lib/components/Account/Referrals/ReferralPayouts/types';
import { ReferralStats } from '@/lib/types/account';
import { ReferralPaymentDto, ReferralPaymentsPageDto, ReferralsDashboardDto } from './types';

export const mapDashboardDtoToReferralStats = (dto: ReferralsDashboardDto): ReferralStats => {
  return {
    totalPaidOut: Number(dto.p?.v ?? 0),
    pending: Number(dto.w?.v ?? 0),
    totalReferrals: Number(dto.tr?.v ?? 0),
    fundedReferrals: Number(dto.fr?.v ?? 0),
    activeReferrals: Number(dto.ar?.v ?? 0),
    commissionRate: Number(dto.cr?.v ?? 0),
    futuresCommissionRate: Number(dto.fcr?.v ?? 0),
  };
};

export function mapReferralPaymentDto(dto: ReferralPaymentDto): ReferralTransaction {
  const statusMap: Record<string, ReferralTransaction['status']> = {
    PAID: 'Completed',
    COMPLETED: 'Completed',
    PENDING: 'Pending',
    CANCELED: 'Failed',
    FAILED: 'Failed',
  };
  return {
    id: dto.i,
    amount: Number(dto.a),
    currency: 'USDC',
    date: dto.t ?? dto.tt,
    status: statusMap[dto.s] ?? 'Pending',
  };
}

export interface ReferralPaymentsResult {
  payments: ReferralTransaction[];
  page: number;
  totalPages: number;
  totalElements: number;
  isEmpty: boolean;
}

export function mapReferralPaymentsPage(dto: ReferralPaymentsPageDto): ReferralPaymentsResult {
  return {
    payments: dto.content.map(mapReferralPaymentDto),
    page: dto.number,
    totalPages: dto.totalPages,
    totalElements: dto.totalElements,
    isEmpty: dto.empty,
  };
}
